
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"25","height":"25","rx":"3","fill":"#FF000B"}}),_c('rect',{attrs:{"x":"12.5","y":"13.5","width":"24","height":"24","rx":"2.5","fill":"#1A592C","stroke":"#FFF8F8"}}),_c('path',{attrs:{"d":"M21.368 19.64l2.816 4.192 2.8-4.192h2.4l-3.936 5.76 3.808 5.6h-2.4l-2.672-4.032L21.496 31H19.08l3.808-5.6-3.936-5.76h2.416zM13.607 14.607a1 1 0 001-1v-9a1 1 0 10-2 0v8h-8a1 1 0 100 2h9zM2.293 3.707L12.9 14.314l1.414-1.415L3.707 2.293 2.293 3.707z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M13.607 14.607a1 1 0 001-1v-9a1 1 0 10-2 0v8h-8a1 1 0 100 2h9zM2.293 3.707L12.9 14.314l1.414-1.415L3.707 2.293 2.293 3.707z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M13.607 14.607a1 1 0 001-1v-9a1 1 0 10-2 0v8h-8a1 1 0 100 2h9zM2.293 3.707L12.9 14.314l1.414-1.415L3.707 2.293 2.293 3.707z","fill":"#FFFEFE"}})])
          )
        }
      }
    